import {createEntityAdapter} from '@reduxjs/toolkit';
import {WorkspaceReservation, GroupWorkspaceReservation} from '../entities';

export const workspaceReservationsAdapter = createEntityAdapter<WorkspaceReservation>();

export const groupWorkspaceReservationAdapter = createEntityAdapter<GroupWorkspaceReservation>();
